export { default as FooterLegal } from './FooterLegal';
